import styled from 'styled-components';

export const Title = styled.h3({
  fontSize: '28rem',
  textAlign: 'center',
  margin: 0,
});

export const SubTitle = styled.p({
  fontSize: '20rem',
  textAlign: 'center',
  fontWeight: 500,
});
